import React, { useEffect, useState } from "react";
import mondaySdk from "monday-sdk-js";
import "@vibe/core/tokens";
import { WarningFilled } from "@ant-design/icons";
import ErrorPage from "../components/errorPage";
import PageLoader from "../components/PageLoader";
import BatchUnlinkPanel from "../components/BatchUnlink/BatchUnlinkPanel";
import { MAX_BATCH_UNLINK_ITEMS } from "../components/BatchUnlink/batchUnlink";
import useBoardAndItems from "../hooks/context/useBoardAndItems";
import useUser from "../hooks/context/userHook";
import { useCheckUserOnboarding } from "../hooks/api/useCheckUserOnboarding";

const monday = mondaySdk();

const BatchUnlinkMenu = () => {
  const { userId } = useUser();
  const { itemIds } = useBoardAndItems();
  const [isViewOnly, setIsViewOnly] = useState(false);

  const { isAuthorized, error } = useCheckUserOnboarding(userId);

  useEffect(() => {
    monday.execute("valueCreatedForUser");
    monday.get("context").then((res: any) => {
      setIsViewOnly(Boolean(res?.data?.user?.isViewOnly));
    });
  }, []);

  if (Array.isArray(itemIds) && itemIds.length > MAX_BATCH_UNLINK_ITEMS) {
    return (
      <div className="flex flex-col justify-center items-center p-7 h-screen text-center">
        <div className="mb-2">
          <WarningFilled className="text-warning-color text-[128px]" />
        </div>
        <p className="text-balance">
          You can only select {MAX_BATCH_UNLINK_ITEMS} items at a time.
        </p>
      </div>
    );
  }

  if (isViewOnly) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="px-4 py-3 bg-red-100 rounded">
          <span className="block sm:inline">As a viewer, you are unable to use the SIMB.</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  if (!itemIds || !isAuthorized) {
    return (
      <div className="App">
        <PageLoader />
      </div>
    );
  }

  return <BatchUnlinkPanel />;
};

export default BatchUnlinkMenu;
